export default __webpack_public_path__ + "static/media/fm.0c77bf24.svg";